function Contact() {
  return (
    <section id="contact">
      <div className="section-divider"></div>
      <h2>Contacto</h2>
      <ul className="contact-list">
        <li>
          <strong>Email</strong>
          <a href="mailto:Jhorellcg31@gmail.com">Jhorellcg31@gmail.com</a>
        </li>
        <li>
          <strong>LinkedIn</strong>
          <a href="https://www.linkedin.com/in/jhorell-condori-5421ba3b3/?skipRedirect=true" target="_blank" rel="noreferrer">
            Jhorell Percy
          </a>
        </li>
        <li>
          <strong>GitHub</strong>
          <a href="https://github.com/jhorellpercy" target="_blank" rel="noreferrer">
            jhorellpercy
          </a>
        </li>
      </ul>
    </section>
  );
}

export default Contact;
